var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('iframe',{staticStyle:{"position":"fixed","top":"100px","left":"0px","bottom":"0px","right":"0px","width":"100%","height":"100%","border":"none","margin":"0","padding":"0","overflow":"hidden","z-index":"999999"},attrs:{"src":_vm.url_notion}})])
}
var staticRenderFns = []

export { render, staticRenderFns }